export const en = {
	'welcome.title': 'Welcome to Elsa',
	'welcome.subtitle': 'Your application is ready to be built',
	'language.english': 'English',
	'language.norwegian': 'Norwegian',
	'login.welcomeBack': 'Welcome Back',
	'login.subtitle': 'Sign in to access your fabrication workspace',
	'login.organizationalAccount': 'Use your organizational account to access the system',
	'login.signInWithAzure': 'Sign in with Azure',
	'login.secureAuth': 'Secure enterprise authentication',
	'login.ssoEnabled': 'Single Sign-On Enabled',
	'login.ssoDescription':
		"You will be redirected to your organization's Azure login page. Use your company credentials to authenticate.",
	'login.badge.secureAuth': 'Secure Authentication',
	'login.badge.cloudBased': 'Cloud Based',
	'login.copyright': '© {year} FabControl. All rights reserved.',
	'mto.emptyState': 'No MTO items found for this purchase order.',
	'mto.emptySearch': 'No matching MTO items found',
};
